export default __webpack_public_path__ + "static/media/only-logo.60a2c43a.png";